export const getConverterOptionsWithDefaults = options => {
  const converterOptions = Object.assign({
    isUngated: () => false,
    hasScope: () => false,
    isNotUsingTimePoints: false
  }, options);
  return converterOptions;
};